// horseList.service.js

import config from './config';
import { handleResponse } from './handle-response';
import { checkToken, authHeader } from './helpers';

export const horseListService = {
	list,
	create,
	update,
	remove,
	listHorses,
	csvExample
};

async function list(urlParams = '') {
	await checkToken();
	let url = `${config.apiUrl}/horse-list/`;
	if (urlParams) {
		url += urlParams;
	}
	const requestOptions = {
		method: 'GET',
		headers: authHeader()
	};
	return fetch(url, requestOptions)
		.then(handleResponse)
		.then(data => data);
}

async function create(body) {
	await checkToken();

	let requestOptions;
	if (body.file instanceof File) {
		const formData = new FormData();
		Object.entries(body).forEach(([key, val]) => {
			if (val instanceof File) {
				formData.append(key, val);
			} else if (Array.isArray(val)) {
				// para cada elemento del array creamos un input repeated
				val.forEach(item => formData.append(key, item));
			} else {
				formData.append(key, val);
			}
		});
		requestOptions = {
			method: 'POST',
			headers: {
				...authHeader(),   // NO pongas Content-Type aquí
			},
			body: formData
		};
	} else {
		requestOptions = {
			method: 'POST',
			headers: {
				...authHeader(),
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		};
	}
	return fetch(`${config.apiUrl}/horse-list/`, requestOptions)
		.then(handleResponse);
}

async function update(id, body) {
	await checkToken();

	let requestOptions;
	if (body.file instanceof File || Array.isArray(body.horses)) {
		const formData = new FormData();
		Object.entries(body).forEach(([key, val]) => {
			if (val instanceof File) {
				formData.append(key, val);
			} else if (Array.isArray(val)) {
				val.forEach(item => formData.append(key, item));
			} else {
				formData.append(key, val);
			}
		});
		requestOptions = {
			method: 'PATCH',
			headers: {
				...authHeader()
			},
			body: formData
		};
	} else {
		requestOptions = {
			method: 'PATCH',
			headers: {
				...authHeader(),
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		};
	}

	return fetch(`${config.apiUrl}/horse-list/${id}/`, requestOptions)
		.then(handleResponse);
}


async function remove(id) {
	await checkToken();
	const requestOptions = {
		method: 'DELETE',
		headers: authHeader()
	};
	return fetch(`${config.apiUrl}/horse-list/${id}/`, requestOptions)
		.then(handleResponse)
		.then(data => data);
}

async function listHorses(horseListId, urlParams = '') {
	await checkToken();
	let url = `${config.apiUrl}/horse-list/${horseListId}/horses/`;
	if (urlParams) {
		url += urlParams;
	}
	const requestOptions = {
		method: 'GET',
		headers: authHeader()
	};
	return fetch(url, requestOptions)
		.then(handleResponse)
		.then(data => data);
}

async function csvExample() {
	await checkToken();
	const requestOptions = {
		method: 'GET',
		headers: authHeader()
	};
	const response = await fetch(
		`${config.apiUrl}/horse-list/csv-example/`,
		requestOptions
	);
	if (!response.ok) throw new Error('Failed to fetch template');
	return response.blob();
}